import useTranslate from 'modules/local/useTranslate'
import {useState} from 'react'
import {NullAsDefault} from 'views/Shared'
import {
    member_assignRole_Api,
    member_leaveAsMember_Api,
    member_manageMemberAccept_Api,
    member_manageMemberEdit_Api,
    member_remove_Api,
    member_removeRoleFromMember_Api,
    member_switchOwner_Api,
    members_manageMemberAdd_Api
} from "../../apis";
import {notifyOnError} from "../AppLocals/factory/createErrorEvent";
import useAsyncAction from "../../modules/asyncCache/useAsyncAction";
import {NotificationActionTypes, successNotify} from "../AppLocals/factory/createNotification";
import {bindQueryParam} from "../AppLocals/functions/routerHelper";


export const useMemberAPI = ({
                                 notifyListeners = {
                                     onMemberAdded: undefined,
                                     onMemberEdited: undefined,
                                     onMemberRemoved: undefined,
                                     onRoleAssigned: undefined,
                                     onRoleAsOwnerAssigned: undefined,
                                     onMemberLeft: undefined,
                                 },
                             }) => {
    const [action, setAction] = useState({type: undefined, value: undefined})
    const t = useTranslate()
    const {
        onMemberAdded = NullAsDefault,
        onMemberEdited = NullAsDefault,
        onMemberRemoved = NullAsDefault,
        onRoleAssigned = NullAsDefault,
        onRoleAsOwnerAssigned = NullAsDefault,
        onMemberLeft = NullAsDefault
    } = notifyListeners ?? {}

    const onError = notifyOnError(t)
    const onCancel = () => {
        setAction({})
    }


    const {handleAsyncAction: onApproveMember} = useAsyncAction({
        onError,
        query: bindQueryParam({}),
        apiInfo: member_manageMemberAccept_Api,
        onSuccess: (result, data) => {
            successNotify(NotificationActionTypes.CREATE, t)
            onMemberAdded(result, data)
            onCancel()
        },
    })

    const {handleAsyncAction: onAddMember} = useAsyncAction({
        onError,
        query: bindQueryParam({}),
        apiInfo: members_manageMemberAdd_Api,
        onSuccess: (result, data) => {
            successNotify(NotificationActionTypes.CREATE, t)
            onMemberAdded(result, data)
            onCancel()
        },
    })

    const {handleAsyncAction: onEditMember} = useAsyncAction({
        onError,
        query: bindQueryParam({}),
        apiInfo: member_manageMemberEdit_Api,
        onSuccess: (result, data) => {
            successNotify(NotificationActionTypes.UPDATE, t)
            onMemberEdited(result, data)
            onCancel()
        },
    })

    const {handleAsyncAction: onRemoveMember} = useAsyncAction({
        onError,
        query: bindQueryParam({}),
        apiInfo: member_remove_Api,
        onSuccess: (result, data) => {
            successNotify(NotificationActionTypes.DELETE, t)
            onMemberRemoved(result, data)
            onCancel()
        },
    })


    const {handleAsyncAction: onLeaveMember} = useAsyncAction({
        onError,
        query: bindQueryParam({}),
        apiInfo: member_leaveAsMember_Api,
        onSuccess: (result, data) => {
            successNotify(NotificationActionTypes.DELETE, t)
            onMemberLeft(result, data)
            onCancel()
        },
    })

    // Gán/thu hồi bậc admin - dùng chung EntityRoleController::assignRoleToMember/removeRoleFromMember
    // (route entity-roles/assign-role/...), cùng 1 nguồn với popover "VAI TRÒ" ở MemberSetting/Members.js -
    // không còn dùng member_setRole_Api (route members/.../set-role) riêng nữa.
    const {handleAsyncAction: onAssignMemberRole} = useAsyncAction({
        onError,
        query: bindQueryParam({role_id: '@admin'}),
        apiInfo: member_assignRole_Api,
        onSuccess: (result, data) => {
            successNotify(NotificationActionTypes.UPDATE, t)
            onRoleAssigned(result, data)
            onCancel()
        },
    })
    const {handleAsyncAction: onRevokeMemberRole} = useAsyncAction({
        onError,
        query: bindQueryParam({role_id: '@admin'}),
        apiInfo: member_removeRoleFromMember_Api,
        onSuccess: (result, data) => {
            successNotify(NotificationActionTypes.UPDATE, t)
            onRoleAssigned(result, data)
            onCancel()
        },
    })
    const {handleAsyncAction: onAssignMemberAsOwner} = useAsyncAction({
        onError,
        query: bindQueryParam({}),
        apiInfo: member_switchOwner_Api,
        onSuccess: (result, data) => {
            successNotify(NotificationActionTypes.UPDATE, t)
            onRoleAsOwnerAssigned(result, data)
            onCancel()
        },
    })

    return {
        onAddMember, onEditMember, onRemoveMember,
        onAssignMemberRole, onRevokeMemberRole, onAssignMemberAsOwner,
        onLeaveMember
    }
}



